(() => {
  if (window.__expoCityCardVariantsBound) return;
  window.__expoCityCardVariantsBound = true;

  document.addEventListener('click', (event) => {
    const option = event.target.closest('[data-ec-variant-button]');
    if (!option) return;

    const selector = option.closest('[data-ec-card-variants]');
    if (!selector) return;

    selector.querySelectorAll('[data-ec-variant-button]').forEach((button) => {
      const selected = button === option;
      button.classList.toggle('is-selected', selected);
      button.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });

    const variantInput = selector.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = option.dataset.variantId;
      variantInput.disabled = false;
      variantInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });
})();
